<template>
  <div :class="{ enter: loading }" class="overlay">
    <div v-pre>
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
        <rect x="0" y="13" width="4" height="5" fill="#F94848">
          <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="1s" repeatCount="indefinite" />
          <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="1s" repeatCount="indefinite" />
        </rect>
        <rect x="10" y="13" width="4" height="5" fill="#F94848">
          <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="1s" repeatCount="indefinite" />
          <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="1s" repeatCount="indefinite" />
        </rect>
        <rect x="20" y="13" width="4" height="5" fill="#F94848">
          <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="1s" repeatCount="indefinite" />
          <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="1s" repeatCount="indefinite" />
        </rect>
      </svg>
    </div>
  </div>
</template>

<script>
import {defineComponent} from "vue";

export default defineComponent({
  name: 'view-loading',
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  }
})
</script>

<style scoped>
@keyframes router-transition-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.overlay {
  position: fixed;
  background: rgba(239, 239, 244, 0.79);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: none;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 1s ease .4s;
}

.overlay.enter {
  display: flex;
  opacity: 1;
  top: 0;
  animation: router-transition-in 0.4s;
}
</style>
